import { Button, Col, Typography } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useTableUser } from "../hooks/useTableUser";
import { IUserResFind } from "../../../redux/@types";
import Table from "../../../shared/components/ui/Table";
import { usersService } from "../../../shared/services";
import { TableColumns } from "../../../shared/components/ui/Table/types";
import { useUsers } from "../hooks/useUsers";

const { Title } = Typography;

const query = { $sort: { id: -1 } };

export const TableUsers = () => {
  const { showDeleteConfirm, changeUserForUpdate } = useTableUser();
  const { setTableProps } = useUsers();
  const columns: TableColumns<IUserResFind> = [
    {
      title: "ID",
      width: 60,
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Nombres",
      width: 70,
      dataIndex: "name",
      filterType: "text",
      key: "name",
    },
    {
      title: "Apellidos",
      width: 70,
      dataIndex: "last_name",
      key: "last_name",
      filterType: "text",
    },
    {
      title: "Correo",
      dataIndex: "email",
      key: "email",
      width: 150,
      filterType: "text",
    },
    {
      title: "Rol",
      width: 60,
      dataIndex: "role",
      key: "role",
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
          { item.role === "admin" && `Administrador`}
          </Col>
        );
      },
      filters: [
        {
          text: "Administrador",
          value: "admin",
        },
      ],
    },
    {
      title: "Estado",
      dataIndex: "status",
      key: "status",
      width: 80,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
          { item.status === "active" && `Activo`}
          { item.status === "inactive" && `Inactivo`}
          </Col>
        );
      },
      filters: [
        { value: "active", text: "Activo" },
        { value: "inactive", text: "Inactivo" },
      ],
    },
    {
      title: "Acciones",
      key: "operation",
      fixed: "right",
      width: 80,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <Button
              type="primary"
              shape="circle"
              onClick={() => changeUserForUpdate(item)}
              icon={<EditOutlined />}
              size="large"
            />
            <Button
              type="primary"
              danger
              onClick={() =>
                showDeleteConfirm(
                  item.id,
                  `${item.name} ${item.last_name}`
                )
              }
              shape="circle"
              icon={<DeleteOutlined />}
              size="large"
            />
          </Col>
        );
      },
    },
  ];

  return (
    <Table<IUserResFind>
      columns={columns}
      fetchQueryProps={query}
      service={usersService}
      onLoad={setTableProps}
    />
  );
};
